<template>
    <nav class="navbar navbar-default">
        <div class="container-fluid">
            <div class="navbar-header">
                <button type="button" class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}"
                        @click="toggleSidebar">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar bar1"></span>
                    <span class="icon-bar bar2"></span>
                    <span class="icon-bar bar3"></span>
                </button>
                <a class="navbar-brand">{{routeName}}</a>
            </div>
            <div class="navbar-right-menu">
                <ul class="nav navbar-nav navbar-right">
                    <li>
                        <div class="selectBoxMargin">
                            <span class="licName">{{licName}}</span>
                            <label class="licLabel" v-if="checkLicensesLength()">Wybierz licencje</label>
                            <el-select :disabled="!checkLicensesLength()" v-model="license" placeholder="Licencja"
                                       :change="changeLicense(license)">
                                <el-option
                                        v-for="item in licenses"
                                        :key="item.lic"
                                        :value="item.lic">
                                </el-option>
                            </el-select>
                        </div>
                    </li>
                    <li>
                        <a href="#" @click="onLogout" class="btn-rotate">
                            <i class="ti-close"></i>
                            <p>
                                Logout
                            </p>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>
<script>
  import User from 'src/models/User'

  export default {
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      },
      lic () {
        return this.$store.getters.lic
      }
    },
    mounted () {
      this.$store.dispatch('getLicenseChange')
      this.license = this.$store.getters.lic
      this.licenses = JSON.parse(localStorage.getItem('userDataOptions')).licList
    },
    data () {
      return {
        license: '',
        activeNotifications: false,
        licenses: Array,
        licName: ''
      }
    },
    watch: {
      lic: function () {
        this.$notify({
          message: 'Wybrana licencja ' + this.license,
          type: 'info'
        })
        this.licName = this.licenseName()
      }
    },
    methods: {
      licenseName () {
        for (let i = 0; i < this.licenses.length; i++) {
          if (this.licenses[i].lic === this.lic) {
            return this.licenses[i].name.Nazwa
          }
        }
      },
      checkLicensesLength () {
        return this.licenses.length > 1
      },
      onLogout () {
        let user = new User()
        user.logout()
        this.$router.push('/login')
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      changeLicense (value) {
        this.$store.commit('changeLic', value)
      }
    }
  }

</script>
<style>
    .selectBoxMargin {
        margin-top: 20px
    }

    .licLabel {
        padding-right: 10px;
    }
    .licName{
        padding-right: 40px;
    }
</style>



// WEBPACK FOOTER //
// TopNavbar.vue?60df9e72